import { Icons, Text } from 'components/atoms'
import { Footer } from 'components/organisms'
import Image1 from 'assets/images/about-1.png'
import Image2 from 'assets/images/about-2.png'

export const About = () => {
  return (
    <>
      <div className="flex flex-col gap-8 pt-[53px] pb-10 px-[22px]">
        <div className="flex gap-[10px]">
          <div className="flex-1">
            <Icons.Logo />
          </div>
          <Text
            text="とは？"
            className="flex items-center !font-black !text-xl !leading-[20.4px] !text-white text-nowrap"
          />
        </div>
        <div>
          <Text
            text="PAPIMO-NET大当り情報公開サービスが提供をしているホールデータの波の状態から未来をよむ、業界内初の革新的なサービス！"
            className="!text-sm !leading-[21px] !text-nortextBtn text-wrap"
          />
          <Text
            text="AIが現在表示されているスランプ波形と近い波形を過去から探し出し、それをもとに3時間後にどうなるかを解析、出玉が2,500玉上昇する確率、−2,500玉〜＋2,500玉の平坦な確率、それ以下の下降確率を算出します。"
            className="!text-sm !leading-[21px] !text-nortextBtn text-wrap"
          />
        </div>
        <img className="rounded-lg" src={Image1} alt="" />
        <Text
          text="また、上昇率が高かった過去波のうち最高に爆発したパターンも表示。ここまで出るかも、という可能性を見ることができます。"
          className="!text-sm !leading-[21px] !text-nortextBtn text-wrap"
        />
        <img className="rounded-lg" src={Image2} alt="" />
        <Text
          text="座るかどうか迷ったときの強力な味方です！"
          className="!font-bold !text-sm !leading-[21px] !text-nortextBtn text-wrap"
        />
      </div>
      <Footer />
    </>
  )
}
